// extracted by mini-css-extract-plugin
module.exports = {"odd":"OddPaperStyles_odd__ahoHA"};